import { HTMLProps } from 'react';

import clsx from 'clsx';
import Link from 'next/link';

import ForecastIcon from '@/components/ForecastIcon';
import { OtherPlaceForecast } from '@/models/OtherPlaceForecast';

type OtherPlaceForecastProps = HTMLProps<HTMLLinkElement> & {
  otherPlaceForecast: OtherPlaceForecast;
};

const OtherPlaceBlock = ({ otherPlaceForecast, className }: OtherPlaceForecastProps) => (
  <Link href={otherPlaceForecast.placeSlug}>
    <a className={clsx('group mr-4 box-content block w-[109px] shrink-0 cursor-pointer snap-start lg:mr-6', className)}>
      <div className="mb-1.5 truncate text-sm text-blue-400 lg:group-hover:text-blue-400/70">
        {otherPlaceForecast.placeName}
      </div>
      <div className="mb-0.5 flex">
        <ForecastIcon iconName={otherPlaceForecast.icon} className="h-10 w-10" alt={otherPlaceForecast.description} />
        <div className="ml-1 pt-1 font-medium">
          <span className="mr-1 text-lg text-grey-900">{otherPlaceForecast.temperatureHigh}&deg;</span>
          <span className="text-sm text-blue-700">{otherPlaceForecast.temperatureLow}&deg;</span>
        </div>
      </div>
      <div className="text-sm leading-[1.15rem] text-grey-800 lg:group-hover:text-grey-800/70">
        {otherPlaceForecast.description}
      </div>
    </a>
  </Link>
);

export default OtherPlaceBlock;
